// Shared AppShell helpers — call from each project's app.js `onCreate`.
// Re-exports the installer/uninstaller defined alongside the component so
// consumers can pull them either via `el.call('installAppShellSync', s)`
// (after they're registered on the project) or by importing them
// directly from the components module when needed.

export {
  installAppShellSync,
  uninstallAppShellSync
} from '../components/AppShell.js'
